import React, { Component } from 'react';
import { getInsuranceProviderDisplayName } from '../util/gearOrderUtil';

class InsuranceDetails extends Component {

    render() {
        const insuranceInfo = this.props.insuranceInfo;
        if (!insuranceInfo) {
            return (null);
        }
        let address = insuranceInfo.claimsAddress;
		let providerDisplayName = insuranceInfo.otherProvider || getInsuranceProviderDisplayName(insuranceInfo.insuranceProvider)
        return (<>
            <div className="separator-2"></div>
            <div className="row">
                <div className="col-sm-6 col-md-4">
                    Provider Name:<strong> {providerDisplayName}</strong>
                </div>
                <div className="col-sm-6 col-md-4">
                    Subscriber Name:<strong> {insuranceInfo.subscriberName ? insuranceInfo.subscriberName: ""}</strong>
                </div>
                <div className="col-sm-6 col-md-4">
                    Subscriber Id:<strong> {insuranceInfo.subscriberId ? insuranceInfo.subscriberId: "N/A"}</strong>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-6 col-md-4">
                    Group Number: <strong> {insuranceInfo.groupNumber ? insuranceInfo.groupNumber: "N/A"}</strong>
                </div>
                <div className="col-sm-6 col-md-4">
                    Subscriber DOB: <strong> {insuranceInfo.subscriberDOB ? insuranceInfo.subscriberDOB: ""}</strong>
                </div>
                <div className="col-sm-6 col-md-4">
                    Subscriber Relationship: <strong> {insuranceInfo.subscriberRelation ? insuranceInfo.subscriberRelation: ""}</strong>
                </div>
            </div>
            {address &&
                <div className="row">
                    <div className="col-md-12">
                        <span>Claims Address:</span><br />
                        {address.address1 && 
                            <span className="col-md-12">
                                <strong> {address.address1}</strong>
                                <br />
                            </span>
                        }
                        {address.address2 && 
                            <span className="col-md-12">
                                <strong> {address.address2}</strong>
                                <br />
                            </span>
                        }
                        { (address.city || address.state || address.zipCode) &&
                            <span className="col-md-12">
                                <strong> {address.city}, {address.state} {address.zipCode}</strong>
                                <br />
                            </span>
                        }
                    </div>
                </div>
            }
            <div className="row">
                <div className="col-sm-4 col-md-4">
                    Phone Number: <strong> {insuranceInfo.phoneNumber && insuranceInfo.phoneNumber.length === 10 ? ("(" + insuranceInfo.phoneNumber.substring(0, 3) + ") " + insuranceInfo.phoneNumber.substring(3, 6) + "-" + insuranceInfo.phoneNumber.substring(6)) : insuranceInfo.phoneNumber}</strong>
                </div>
            </div>
		</>);
    }

}
export default InsuranceDetails;
